<template>
	<div class="phabout">

		<div class="imgpop" v-if="popnos">
			<div class="imgpopcont">
				<img :src="popcont"></img>
				<div class="el-icon-circle-close closevi" @click="pupclose()"></div>
			</div>
		</div>
		<el-backtop ></el-backtop>
		<hpheader></hpheader>
		<div class="phabbanner">
			<div class="paabbanner-hea">
				{{info.about}}
			</div>
			<div class="paabbanner-foo">
				<div class="paabbanner-foo-text" v-for="(item,index) in pcintrochtm" :key="index" >
					{{ item }}
				</div>
			</div>
		</div>

		<div class="vision">
			<div class="vision-cont">
				<div class="vision-itemtopleft">
					<div class="topleft-img" >
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phaboutimg/phaboutvision1.png" />
					</div>
					<div class="vision-text">
						<div class="heaname">
							{{leftuscreated[0].ustitle}}
						</div>
						<div class="footitle">
							<div v-for="(item,index) in about_all.cost" :key="index">
								{{ item }}
							</div>
						</div>
					</div>
				</div>
				<div class="vision-itemtopleft">
					<div class="topleft-img">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phaboutimg/phaboutvision2.png" />
					</div>
					<div class="vision-text">
						<div class="heaname">
							{{leftuscreated[1].ustitle}}
						</div>
						<div class="footitle" >
							<div v-for="(item,index) in about_all.style" :key="index">
								{{ item }}
							</div>
						</div>
					</div>
				</div>
				<div class="vision-itemtopleft">
					<div class="topleft-img">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phaboutimg/phaboutvision3.png" />
					</div>
					<div class="vision-text">
						<div class="heaname">
							{{rightuscreated[0].ustitle}}
						</div>
						<div class="footitle">
							<div v-for="(item,index) in about_all.rule" :key="index">
								{{ item }}
							</div>
						</div>
					</div>
				</div>
				<div class="vision-itemtopleft">
					<div class="topleft-img">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phaboutimg/phaboutvision4.png" />
					</div>
					<div class="vision-text">
						<div class="heaname">
							{{rightuscreated[1].ustitle}}
						</div>
						<div class="footitle">
							<div v-for="(item,index) in about_all.vision" :key="index">
								{{ item }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="phaboutpic">
			<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phaboutimg/phaboutpic.png" />
		</div>
		<div class="phaboutcourse">
			<div class="phabcourse-hea">
				{{info.course}}
			</div>
			<div class="aboufoo-cont">
				<div class="aboufoo-item" :class="aboutnumsimg==item.img_num?'':'abouimgmin'" v-for="(item,index) in companycours" :key="index">
					<div class="abfooitem-left">
						<div class="aboufoo-img"  v-for="(ite,inde) in item.images" :key="inde" >
							<img @click="pupimg(ite)" :src="ite" />
						</div>
					</div>
					<div class="lien-icon">
						<div class="abouicon"></div>
						<div class="aboulien"></div>

					</div>
					<div class="abfooitem-right">
						<div class="aboufoo-time">{{item.years}} {{year}}</div>
						<div class="aboufoo-title" >
							<div class="aboufoo-title-text" v-for="(ite,idx) in item.content" :key="idx">
								{{ ite }}
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="aboufoo-but">
				<div class="aboufoo-butcont"  v-if="more_show"  @click="handleClickMore()" >{{info.more}}
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcabdown.png" />
				</div>
			</div>

		</div>
		<div class="phabounewc">
			<!--			<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phaboutimg/phaboutnew.png" />-->
			<!--			<div class="phabounewc-hea" @click="navtonew">-->
			<!--				<div class="phabtitele">新闻中心</div>-->
			<!--				<span>了解更多></span>-->
			<!--			</div>-->
			<video id="video" controls :src="video_url"  :poster="img_url" ></video>
		</div>
		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	export default{
		data(){
			return{
				id:'',
				aboutnumsimg:1,
				popnos:false,
				popcont:'',
				more_show:true,//显示更多
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				acindex:1,
				controls: true,
				year:"年",
				pcintrochtm:'',
				companycours:'',
				companyarou:'',
				comhonor:'',
				page:1,
				about_all:[],
				pcnewtyp:'',
				newlists:'',
				newnav:2,
				value: '',
				valuelang: '',
				info:{
					'about': "关于啄木鸟",
					'around': "公司环境",
					'honor': '公司荣誉',
					'news' : '新闻中心',
					'course' : '公司历程',
					'more' : "显示更多",
					'special': '专题',
				},
				leftuscreated :  [
					{'ustitle':'我们的核心价值观','usmintitle':'认真、诚信、感恩'},
					{'ustitle':'我们的作风','usmintitle':'想就有办法，做就做第一快、准、狠'},
				],
				rightuscreated : [
					{'ustitle':'我们的准则','usmintitle':'忠诚、认真、专业、创新、追求卓越以客户为核心,一切为客户而改变'},
					{'ustitle':'我们的愿景','usmintitle':'创世界一流企业，当中国起先锋,赢得全球客户的尊重和信赖，实现啄木鸟人的，梦想'},
				],
				video_url:'',
				img_url:'',
			}
		},
		created() {
			window.scrollTo(0,0);

			this.pageParam()
			this.pcintroduction()
			this.pccompanycourse();
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

				this.$router.push({path:'./pcabout',query:{e:1}})
			}
			this.ress()

		},
		components:{
			hpfooter,
			hpheader
		},
		methods:{
			pupclose(){
				this.popnos=false
			},
			pupimg(e){
				console.log(e)
				this.popcont=e
				this.popnos=true
			},
			handleClickMore(){ // 点击显示更多
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					mold:'pc',
					page: ++this.page,
					pageSize:5,
				}
				this.$api.get_company_course(data).then((res) => {
					if (res.data.length == 0){
						this.more_show = false;
						return;
					}
					res.data.forEach((el)=>{
						this.companycours.push(el);
					})
				});
			},
			pcintroduction(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),

				}
				this.$api.get_about_us(data).then((res) => {
					this.pcintrochtm=res.data.content
					this.about_all=res.data
					this.video_url = res.data.url
					this.img_url = res.data.img
				});
			},
			pccompanycourse(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					mold:'pc',
					page:1,
					pageSize:5,
				}
				this.$api.get_company_course(data).then((res) => {
					this.companycours=res.data
				});
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.leftuscreated =  [
						{'ustitle':'我们的核心价值观','usmintitle':'认真、诚信、感恩'},
						{'ustitle':'我们的作风','usmintitle':'想就有办法，做就做第一快、准、狠'},
					]
					this.rightuscreated =  [
						{'ustitle':'我们的准则','usmintitle':'忠诚、认真、专业、创新、追求卓越以客户为核心,一切为客户而改变'},
						{'ustitle':'我们的愿景','usmintitle':'创世界一流企业，当中国起先锋,赢得全球客户的尊重和信赖，实现啄木鸟人的，梦想'},
					]
					this.year = "年"
					this.info = {
						'about': "关于啄木鸟",
						'around': "公司环境",
						'honor': '公司荣誉',
						'news' : '新闻中心',
						'course' : '公司历程',
						'more' : "显示更多",
						'special': '专题',
					}
				}else{
					this.created = "Woodpecker creation"
					this.leftuscreated =  [
						{'ustitle':'Our core values','usmintitle':'Earnest, honest and grateful'},
						{'ustitle':'Our style','usmintitle':'Think there is a way, do it first, fast, accurate and obscene'},
					]
					this.rightuscreated =  [
						{'ustitle':'Our guidelines','usmintitle':'Loyal, serious, professional, innovative, pursuing excellence, taking customers as the core and changing everything for customers'},
						{'ustitle':'Our vision','usmintitle':'Create a world-class enterprise, be a pioneer in China, win the respect and trust of global customers, and realize the dream of woodpecker'},
					]
					this.year = "year"
					this.info = {
						'about': "ABOUT WOODPECKER",
						'around': "Company environment",
						'honor': 'Company honor',
						'news' : 'News Center',
						'course' : 'Company history',
						'more' : "More",
						'special': 'Special',
					}

				}
			},

			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
			navtonew(){
				this.$router.push({path: '/phnews'})
			},
		}

	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phabout{
		padding-top: 0.88rem;
		/*padding-bottom: 0.6rem;*/
		background: #FAFAFA;
	}
	.phabout-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
	}
	.phabouthea-left{
		margin-left: 0.3rem;
		width: 0.97rem;
		height: 0.5rem;
	}
	.phabouthea-left img{
		width: 100%;
		height: 100%;
	}
	.phabouthea-right{
		margin-right: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
	}
	.phabouthea-right img{
		width: 100%;
		height: 100%;
	}
	.phabbanner{
		width: 7.5rem;
    height: 14rem;
    background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20250831/903c1d235bbfd5da90392635ca575cd5.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
		padding: 0.6rem 0.3rem;
		box-sizing: border-box;
	}
	.paabbanner-hea{
		font-size: 0.32rem;
		font-weight: 500;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
	}
	.paabbanner-foo{
		font-size: 0.24rem;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 1px;
		margin-top: 0.24rem;
	}
	.vision{
		display: flex;
		justify-content: center;
		width: 7rem;
		min-height: 7rem;
		background-color: #FFFFFF;
		margin-left: 0.26rem;
		margin-top: -6rem;
		border-radius: 0.12rem;
	}
	.vision-cont{
		/*align-items: center;*/
		/*margin-top: -1rem;*/
		padding-bottom: .3rem;
	}
	.vision-itemtopleft{
		width: 6rem;
		display: -webkit-flex;
		display: flex;
		padding-top: 0.3rem;
		box-sizing: border-box;
	}
	.vision-text {
		width: 5rem;
		margin-left: .2rem;
	}
	/*.vision-itemtopleft:nth-child(1){*/
	/*	box-shadow: 0.01rem 0.00rem 0rem 0rem  #D8D8D8;*/
	/*	margin-right: 0.05rem;*/
	/*	margin-top: -0.05rem;*/
	/*}*/
	/*.vision-itemtopleft:nth-child(4){*/
	/*	box-shadow: -0.01rem -0.00rem 0rem 0rem  #D8D8D8;*/
	/*}*/
	.heaname{
		/*width: 2.9rem;*/
		/*text-align: center;;*/
		font-size: 0.24rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-top: 0.30rem;
	}
	.footitle{
		/* width: 2.9rem; */
		/*text-align: center;*/
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		letter-spacing: 0.01rem;
		margin-top: 0.16rem;
	}
	.footitle p{
		margin: 0;
	}
	.topleft-img{
		width: 0.8rem;
		height: 0.8rem;
	}
	.topleft-img img{
		width: 100%;
		height: 100%;
	}
	.phaboutpic{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.phaboutpic img{
		margin-top: 0.24rem;
		width: 6.9rem;
		height: 3rem;

	}

	.aboufoo-cont{
		width: 7.5rem;
	}
	.lien-icon{
		display: flex;
		align-items: center;
		position: relative;
		margin-left: 0.24rem;
		margin-right: 0.24rem;
	}
	.abouicon{
		width: 0.15rem;
		height: 0.15rem;
		border-radius: 50%;
		background: #D8D8D8;
		position: absolute;
		top: 0rem;
		left: -0.07rem;
	}
	.aboulien{
		width: 0.01rem;
		height: 6rem;
		background: #EAEAEA;
	}

	.aboufoo-item:first-child{
		margin-top: 0;
	}
	.aboufoo-item:last-child .aboulien{
		height: 3rem;
	}
	.aboufoo-item{
		width: 7.5rem;
		display: flex;
		flex-direction: row;
		text-align: left;
		justify-content: center;
		margin-top: -2rem;
	}
	.aboufoo-item:nth-child(2n){
		width: 7.5rem;
		display: flex;
		flex-direction: row-reverse;
		justify-content: center;
		text-align: right;
	}
	.aboufoo-img{
		margin-top: 0.4rem;
		width: 3.21rem;
		height: 1.87rem;
		border-radius: 0.2rem;
		overflow: hidden;
	}
	.abfooitem-left{
		width: 3.22rem;
		display: flex;
		flex-wrap: wrap;
		height: 100%;
	}
	/* .abouimgmin .abfooitem-right{
		width: 3.21rem !important;
		display: flex;
		flex-direction: column;
		align-items: center;

	} */
	.abouimgmin .aboufoo-img{
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		width: 1.5rem;
		height: 1.07rem;
		border-radius: 0.2rem;
		margin-right: 0.10rem;
	}
	/* .abouimgmin .aboufoo-img */
	/* .abouimgmin{
		display: flex;
		justify-content:space-between;
	} */
	.abouimgmin .aboufoo-img img{

		width: 100%;
		height: 100%;
		border-radius: 0.2rem;
	}
	.aboufoo-img img{

		width: 100%;
		height: 100%;
		border-radius: 0.2rem;
	}
	.aboufoo-time{
		font-size: 0.18rem;
		font-weight: 400;
		color: #5d5f5f;
		padding-bottom: .3rem;
	}
	.aboufoo-title{
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-top: 0.15rem;
	}
	.aboufoo-title span,.aboufoo-title p{
		display: block;
		font-size: 0.24rem !important;
		line-height: 1.6;
	}
	.aboufoo-title p{
		margin: 0;
	}
	.aboufoo-heafer{
		margin-top: 0.8rem;
		margin-bottom: 0.8rem;
		width: 7.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.02rem;
	}
	.aboufoo-but{
		width: 7.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.02rem;
		margin-top: 0.6rem;
	}
	.aboufoo-butcont{
		width: 1.76rem;
		height: 0.6rem;
		border-radius: 0.04rem;
		border: 0.01rem solid #CCCCCC;
		font-size: 0.14rem;
		font-weight: 400;
		color: #999999;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.aboufoo-butcont img{
		width: 0.24rem;
		height: 0.24rem;
		margin-left: 0.06rem;
	}
	.abfooitem-right{
		width: 3.21rem;
		display: flex;
		flex-direction: column;
	}
	.phabounewc{
		width: 6.89rem;
		height: 4rem;
		margin-left: 0.3rem;
		margin-top: 0.6rem;
		position: relative;
		margin-bottom: 0.6rem;
	}
	.phabounewc img{
		width: 6.89rem;
		height: 4rem;
	}
	.phabounewc-hea{
		position: absolute;
		top: 2.6rem;
		left: 2.67rem;
		font-size: 0.4rem;
		font-weight: 500;
		color: #FFFFFF;
		letter-spacing: 0.02rem;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.phabounewc-hea span{
		margin-top: 0.1rem;
		font-size: 0.24rem;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
		border-bottom: 0.01rem solid #fff;
	}
	.phabcourse-hea{
		font-size: 0.36rem;
		font-weight: 500;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 0.64rem;
		margin-bottom: 0.26rem;
	}
	.imgpop{

	}
	.imgpopcont{
		width: 100vw;
		height: 100vh;
		background: rgba(0,0,0,.38);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;

	}
	.imgpopcont{

		/* position: relative; */
	}
	.imgpopcont img{
		width: 100vw;
		height: 4.2rem;
	}
	.closevi{
		font-size: 0.5rem;
		color: #fff;
		position: absolute;
		top: 4.2rem;
		right: -0.1rem;
		z-index: 99;
	}
	#video {
		width: 100%;
	}
	.paabbanner-foo-text{
		margin-top: 50px;
	}
	.aboufoo-title-text  {
		font-size: 40px;
	}
</style>
